import { z } from 'zod';
import { zodToJsonSchema } from 'zod-to-json-schema';
import { SuitabilityFacts, SuitabilityAssessment } from './suitability.js';
export const ProjectPlanBody = z.object({
    name: z.string().trim().min(1).max(100),
    slug: z.string().trim().min(3).max(63).optional(),
    region: z.literal('ap-southeast-1').optional(),
    facts: SuitabilityFacts,
}).strict();
export const ProjectPlan = z.object({
    schemaVersion: z.literal(1),
    id: z.string().uuid(), orgId: z.string().uuid(), actorUserId: z.string().uuid(),
    target: z.object({ name: z.string(), slug: z.string(), region: z.literal('ap-southeast-1') }).strict(),
    environment: z.string().min(1).max(32),
    policyRevision: z.string().min(1).max(100),
    factsFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
    eligibleResources: z.array(z.enum(['d1_database', 'r2_bucket', 'kv_namespace', 'vectorize_index', 'worker_script'])).max(5),
    state: z.enum(['eligible', 'expired', 'invalidated']),
    assessment: SuitabilityAssessment,
    createdAt: z.string().datetime(), expiresAt: z.string().datetime(),
    /** Status of the deployed flow, not a permission carried by this document. */
    provisioningGate: z.enum(['not_enforced', 'enforced']),
    note: z.string().max(1000),
}).strict();
export const ProjectPlanResponse = z.object({ plan: ProjectPlan }).strict();
export function projectPlanBodyJsonSchema() {
    return zodToJsonSchema(ProjectPlanBody, { target: 'jsonSchema7', $refStrategy: 'none' });
}
//# sourceMappingURL=project-plans.js.map